function playVideo() {
    var playButton = document.querySelector('#Deferred-Poster-Modal-Button');
    var videoType = playButton.getAttribute('data-video-type');

    if (videoType === 'youtube') {
        var youtubePlayer;
        var youtubeIframe = document.getElementById('youtube-player');

        function onYouTubeIframeAPIReady() {
            youtubePlayer = new YT.Player(youtubeIframe, {
                events: {
                    'onReady': onPlayerReady
                }
            });
        }

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        onYouTubeIframeAPIReady();
    }
    else if (videoType === 'vimeo') {
        var vimeoPlayer;
        var vimeoIframe = document.getElementById('vimeo-player');

        vimeoPlayer = new Vimeo.Player(vimeoIframe);

        vimeoPlayer.play().catch(function (error) {
            console.error('Erreur de lecture de la vidéo Vimeo :', error);
        });
    }
}

window.addEventListener('load', function () {
    var playButton = document.querySelector('#Deferred-Poster-Modal-Button');

    playButton.addEventListener('click', function () {
        var videoType = playButton.getAttribute('data-video-type');
        var videoId = playButton.getAttribute('data-video-id');
        playVideo(videoType, videoId);
    });
});